import BaseApi from '../baseApi';

export default class ConfigurationApi extends BaseApi {
  constructor(obj){
      obj = obj || {};
      super(obj);
  }

  findAll() {
    return new Promise((resolve, reject) => {
      return this.api
        .get('/configurations')
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  findById(id) {
    id = id || {};

    return new Promise((resolve, reject) => {
      return this.api
        .get(`/configurations/${id}`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  findBySession(session) {
    return new Promise((resolve, reject) => {
      return this.api
        .get(`/configurations/session/${session}`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  findByGroup(group) {
    return new Promise((resolve, reject) => {
      return this.api
        .get(`/configurations/group/${group}`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  updateList(configurations) {
    configurations = configurations || [];

    return new Promise((resolve, reject) => {
      return this.api
        .put(`/configurations/list`, configurations)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  findSmtp() {
    return new Promise((resolve, reject) => {
      return this.api
        .get(`/configurations/credentials/smtp`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  clearSmtp() {
    return new Promise((resolve, reject) => {
      return this.api
        .delete(`/configurations/credentials/smtp`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  findCredentialsStatus() {
    return new Promise((resolve, reject) => {
      return this.api
        .get(`/configurations/credentials/status`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  testSmtp(settings) {
    settings = settings || {};

    return new Promise((resolve, reject) => {
      return this.api
        .post(`/configurations/credentials/smtp/test`, settings)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  findAutentique() {
    return new Promise((resolve, reject) => {
      return this.api
        .get(`/configurations/credentials/autentique`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  updateAutentique(configuration) {
    configuration = configuration || {};

    return new Promise((resolve, reject) => {
      return this.api
        .put(`/configurations/credentials/autentique`, configuration)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  findDocusign() {
    return new Promise((resolve, reject) => {
      return this.api
        .get(`/configurations/credentials/docusign`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  updateDocusign(configuration) {
    configuration = configuration || {};

    return new Promise((resolve, reject) => {
      return this.api
        .put(`/configurations/credentials/docusign`, configuration)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }
}
